import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateStaffSection(section, founderImg, founderBlock, line, grid, tiles) {

  // Individual tweens 
  // Founder image
  let founderImgTween = founderImg ? gsap.to(founderImg, {
    duration: 0.6,
    opacity: 1,
    x: 0,
    ease: "power1.in",
  }) : null;

  // Founder block
  let founderBlockTween = founderBlock ? gsap.to(founderBlock, {
    duration: 0.6,
    opacity: 1,
    x: 0,
    ease: "power1.in",
  }, "-=0.2") : null;

  // Diagonal red line
  let lineTween = line ? gsap.to(line, {
    width: "200%",
    duration: 1,
    ease: "power1.out",
  }) : null;

  // Staff grid tiles 
  let tilesTween = tiles ? gsap.to(tiles, {
    duration: 0.8,
    scale: 1,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Timelines
  // Founder timeline
  let tl1 = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
    },
  });

  // Staff grid timeline
  let tl2 = gsap.timeline({
    scrollTrigger: {
      trigger: grid,
      start: "top 80%",
    },
  });

  tl1
    .add(founderImgTween)
    .add(founderBlockTween)
    .add(lineTween);

  tl2.add(tilesTween);

}